import {
  useLocalStorage,
  ROUTESNAMES,
  MAINROLES,
  lowerString,
  SPECIFICROLES,
} from "@/helpers";
import { useGlobalStore } from "@/store/Modules/global";
// checks if the user is authenticated and if not, it reroute them to the right login page

export default function checkUserAuthentication({ specificRole, loginPage, role }) {   
  
  return defineNuxtRouteMiddleware(async (to, from) => {
    let redirectionPath = "";
    // directs user to the login page if not authenticated
    const changeRedirectionPath = (newPath) => {
      redirectionPath = newPath;
    };
    
    role = lowerString(role) || "";
    const globalStore = useGlobalStore();
    const lsCopy = useLocalStorage({ type: "get" });

    // gets all tokens from the local storage
    const userToken =
      lsCopy?.user?.token || globalStore.localStorageCopy?.user?.token;
    const adminToken =
      lsCopy?.admin?.token || globalStore.localStorageCopy?.admin?.token;

    const currentUserType = lowerString(
      lsCopy?.user?.role || globalStore.localStorageCopy?.user?.role || ""
    );
    const currentAdminType = lowerString(
      lsCopy?.admin?.role || globalStore.localStorageCopy?.admin?.role || ""
    );
    // if it's the login page and the token is available, redirect them to the page they wanna go to
    if (loginPage && loginPage?.type) {
      if (loginPage.type === MAINROLES.admin && adminToken) {
        currentAdminType === SPECIFICROLES.admin
          ? changeRedirectionPath(ROUTESNAMES.admin.categories)
          : currentAdminType === SPECIFICROLES.moderator_admin &&
            changeRedirectionPath(ROUTESNAMES.moderator_admin.categories);
      } else if (loginPage.type === MAINROLES.user && userToken) {
        changeRedirectionPath(
          loginPage?.previousPath?.type
            ? loginPage.previousPath.type
            : ROUTESNAMES.user.homepage
        );
      }
    } else if (
      // if admin-typed role
      lowerString(role) === MAINROLES.admin &&
      (lowerString(specificRole) !== currentAdminType || !adminToken)
    ) {
      // clears the admin object in local storage
      useLocalStorage({
        type: "set",
        value: {},
        key: MAINROLES.admin || "",
      });
      if (
        specificRole === SPECIFICROLES.reseller ||
        specificRole === SPECIFICROLES.moderator_reseller
      ) {
        changeRedirectionPath(ROUTESNAMES.user.login);
      } else {
        changeRedirectionPath(ROUTESNAMES.panel.login);
      }

    } else if (
      // else if user-typed role
      lowerString(role) === MAINROLES.user &&
      ((currentUserType !== SPECIFICROLES.user &&
        currentUserType !== SPECIFICROLES.reseller &&
        currentUserType !== SPECIFICROLES.guest &&
        currentUserType !== SPECIFICROLES.moderator_reseller) ||
        !userToken)
    ) {
      // clears the user object from local storage
      useLocalStorage({
        type: "set",
        value: {},
        key: MAINROLES.user || "",
      });
      // redirect them to the user-login page
      changeRedirectionPath(ROUTESNAMES.user.login);
    }
    if (redirectionPath) {
      return navigateTo(redirectionPath);
    }
  });
}
